/**
 * Gateway AI integration — frontend-only defaults.
 * Provider credentials, endpoint, and model live server-side. The readiness
 * endpoint returns only whether the selected backend provider can be used.
 */

const CORE_URL =
  (typeof window !== "undefined" && window.CS_GATEWAY_CONFIG?.CORE_URL) ||
  process.env.REACT_APP_CORE_URL ||
  "http://localhost:8090";

const AI_CONFIG = {
  temperature: 0.4,
  maxTokens: 16000,
  timeout: 180000,
};

export const getCoreUrl = () => CORE_URL;
export const getAIConfig = () => ({ ...AI_CONFIG });

export const checkServerConfig = async () => {
  try {
    const res = await fetch(`${CORE_URL}/api/ai/config`, {
      credentials: "include",
    });
    if (res.ok) {
      const data = await res.json();
      return data.ready === true;
    }
  } catch {}
  return false;
};
